// A route as its editor holds it, and as POST/PUT /routes takes it. The route
// editor, the routes list's Duplicate and a target's "Add to a route" all send
// through toBody, so a route is never saved with fields it didn't have.
export const emptyRoute = category => ({
  name: '', category: category || 'errors', triggerKinds: [], minSeverity: 'info', filters: [], schedule: null,
  deliveryMode: 'immediate', digestMinutes: 0, actions: [], scopeType: 'platform', organizationID: null, choosing: false
})

// A route the API returned, in the editor's shape (lists never missing;
// choosing: it names alerts rather than taking the whole category).
export const editableRoute = r => ({
  ...emptyRoute(r.category), ...r, triggerKinds: r.triggerKinds || [], actions: r.actions || [], filters: r.filters || [],
  choosing: (r.triggerKinds || []).length > 0
})

// toBody is exactly what POST/PUT /routes accepts.
export const toBody = r => ({
  name: r.name.trim(), scopeType: r.scopeType, organizationID: r.organizationID, category: r.category, triggerKinds: r.triggerKinds,
  minSeverity: r.minSeverity, filters: r.filters, schedule: r.schedule, deliveryMode: r.deliveryMode,
  digestMinutes: r.deliveryMode === 'digest' ? r.digestMinutes : 0,
  actions: r.actions.filter(a => a.targetID).map(a => ({ targetID: a.targetID, enabled: a.enabled !== false, mapping: a.mapping || {} }))
})

// The route with one more action: the target, switched on, with the type's
// default message.
export const withTarget = (route, targetID) => {
  const r = editableRoute(route)
  return { ...r, actions: [...r.actions, { targetID, enabled: true, mapping: {} }] }
}
